export default __webpack_public_path__ + "static/media/mobileAd.fb655a6d.png";